import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {PromoCodeRequest} from "../interface/promoCodeRequest";
import {PromoCodeResponse} from "../interface/promoCodeResponse";
import {DiscountRequest} from "../models/discountRequest";
import {DiscountResponse} from "../interface/discountResponse";

@Injectable({
  providedIn: "root"
})
export class PromoCodeService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  findAll(page: number = 0, size: number = 9): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get(`${this.apiUrl}/promo-code/all`, {params})
  }

  create(promoCodeRequest: PromoCodeRequest): Observable<PromoCodeResponse> {
    return this.http.post<PromoCodeResponse>(`${this.apiUrl}/promo-code`, promoCodeRequest);
  }

  deleteById(id: bigint): Observable<any> {
    return this.http.delete(`${this.apiUrl}/promo-code/delete/promoCodeId/${id}`);
  }

  discount(discountRequest: DiscountRequest): Observable<DiscountResponse> {
    const url = `${this.apiUrl}/promo-code/discount`;
    return this.http.post<DiscountResponse>(url, discountRequest);
  }

  discountByPrice(price: number, code: string): Observable<DiscountResponse> {
    const body = {price: price, code: code};
    const url = `${this.apiUrl}/promo-code/discount/price`;
    return this.http.post<DiscountResponse>(url, body);
  }
}
